import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  PaperProps,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import theme from "common/theme/theme";
import Draggable from "react-draggable";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export interface SimpleModalProps {
  children: React.ReactNode;
  title: string;
  maxWidth: any;
  fullScreen?: boolean;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  testId?: string;
}

export interface MyDialogTitleProps {
  id: string;
  children: React.ReactNode;
  setIsFullScreen: any;
  isFullScreen: boolean;
  onClose: () => void;
}

const MyDialogTitle = (props: MyDialogTitleProps) => {
  const { children, setIsFullScreen, isFullScreen, onClose } = props;

  return (
    <DialogTitle
      sx={{
        margin: 0,
        padding: theme.spacing(1, 3),
        backgroundColor: theme.accent.light,
        cursor: "move",
        color: theme.secret.darkgray,
      }}
    >
      <Typography variant="dialogtitle">{children}</Typography>
      <IconButton
        aria-label="close"
        sx={{
          position: "absolute",
          right: theme.spacing(4.5),
          top: theme.spacing(.5),
          color: theme.secret.darkgray,
        }}
        onClick={() => setIsFullScreen(!isFullScreen)}
      >
        {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
      {onClose ? (
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: theme.spacing(.5),
            top: theme.spacing(.5),
            color: theme.secret.darkgray,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function SimpleModal(props: SimpleModalProps) {
  const { children, title, maxWidth, fullScreen, isOpen, setOpen, testId } =
    props;
  const [isFullScreen, setIsFullScreen] = useState<boolean>(
    fullScreen ?? false
  );
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        fullWidth
        fullScreen={isFullScreen}
        maxWidth={maxWidth}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        open={isOpen}
        data-testid={testId ? `${testId}ModalWrapper` : "modalWrapper"}
        PaperComponent={PaperComponent}
        PaperProps={{ 
          style: { borderRadius: 0 }
        }}
      >
        <MyDialogTitle
          setIsFullScreen={setIsFullScreen}
          isFullScreen={isFullScreen}
          id="draggable-dialog-title"
          onClose={handleClose}
        >
          {title}
        </MyDialogTitle>
        <DialogContent
          sx={{ padding: theme.spacing(3) }}
          data-testid={testId ? `${testId}ModalContent` : "modalContent"}
        >
          {children}
        </DialogContent>
      </Dialog>
    </div>
  );
}
